/* Two Pack Bag — gaveta do carrinho e página /cart (sem app). A marcação vem renderizada pelo Liquid;
   aqui só se abre, fecha e troca o conteúdo pela Section Rendering API depois de cada mudança. */
(function () {
  if (window.TpbCart) return;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SEC = 'tpb-cart-drawer';
  var pagina = function () { return document.getElementById('tpb-cartpage'); };
  var gaveta = function () { return document.getElementById('tpb-cart'); };

  function secaoPagina() {
    var p = pagina(); if (!p) return null;
    var s = p.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '') : null;
  }
  function trocar(html, id, alvo) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var novo = doc.getElementById(id), velho = document.getElementById(id);
    if (!novo || !velho) return;
    if (alvo === 'gaveta') novo.className = velho.className; // mantém aberta
    velho.replaceWith(novo);
  }
  function contador(n) {
    document.querySelectorAll('.tpb-hd__count').forEach(function (c) { c.textContent = n; c.hidden = n < 1; });
    if (n > 0 && !document.querySelector('.tpb-hd__count')) {
      document.querySelectorAll('[data-tpb-cart-open]').forEach(function (a) {
        var s = document.createElement('span'); s.className = 'tpb-hd__count'; s.textContent = n; a.appendChild(s);
      });
    }
  }
  function atualizar(resp) {
    var secoes = [SEC], sp = secaoPagina(); if (sp) secoes.push(sp);
    var pronto = resp && resp.sections ? Promise.resolve(resp.sections)
      : fetch(R + '?sections=' + secoes.join(','), { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    return pronto.then(function (s) {
      if (s[SEC]) trocar(s[SEC], 'tpb-cart', 'gaveta');
      if (sp && s[sp]) trocar(s[sp], 'tpb-cartpage');
      var g = gaveta(); contador(g ? +g.dataset.count : 0);
    });
  }
  // brindes sozinhos no carrinho (sem produto pago) saem junto
  function limparBrindes() {
    var g = gaveta(); if (!g || +g.dataset.pagos > 0 || +g.dataset.count === 0) return Promise.resolve();
    return fetch(R + 'cart/clear.js', { method: 'POST', credentials: 'same-origin' }).then(function () { return atualizar(); });
  }
  function ocupado(on) {
    var g = gaveta(), p = pagina();
    if (g) g.classList.toggle('is-busy', on); if (p) p.classList.toggle('is-busy', on);
  }
  function mudar(key, q) {
    ocupado(true);
    var secoes = [SEC], sp = secaoPagina(); if (sp) secoes.push(sp);
    return fetch(R + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, q), sections: secoes })
    }).then(function (r) { return r.json(); }).then(atualizar).then(limparBrindes)
      .catch(function () { location.reload(); }).then(function () { ocupado(false); });
  }
  function abrir() {
    var g = gaveta(); if (!g) { location.href = R + 'cart'; return; }
    if (pagina()) return; // na própria página do carrinho a gaveta não abre
    g.classList.add('is-open'); g.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tpb-cart-aberto');
    var f = g.querySelector('.drawer__inner'); if (f) f.focus({ preventScroll: true });
  }
  function fechar() {
    var g = gaveta(); if (!g) return;
    g.classList.remove('is-open'); g.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tpb-cart-aberto');
  }
  function adicionar(items) {
    return fetch(R + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: [SEC] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(atualizar).then(abrir);
  }
  window.TpbCart = { open: abrir, close: fechar, refresh: atualizar, add: adicionar };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-tpb-cart-close]')) { e.preventDefault(); fechar(); return; }
    if (t.closest('[data-tpb-cart-open]') && gaveta() && !pagina()) { e.preventDefault(); abrir(); return; }
    var add = t.closest('[data-tpb-add]');
    if (add) { e.preventDefault(); add.disabled = true; ocupado(true); adicionar([{ id: +add.dataset.tpbAdd, quantity: 1 }]).catch(function () {}).then(function () { ocupado(false); }); return; }
    var q = t.closest('[data-tpb-q]');
    if (q) {
      var linha = q.closest('[data-key]'); if (!linha) return;
      e.preventDefault(); mudar(linha.dataset.key, +q.dataset.tpbQ);
    }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('.quantity__input'); if (!i) return;
    var linha = i.closest('[data-key]'); if (linha) mudar(linha.dataset.key, parseInt(i.value, 10) || 0);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });
  // formulário de compra simples (produto em destaque da home): adiciona sem sair da página
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form[action*="/cart/add"]') || f.dataset.tpbNativo != null || !window.fetch) return;
    if (f.querySelector('.tpb-mp__atc')) return; // o bloco do produto já trata o próprio envio
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f); fd.append('sections', SEC);
    fetch(R + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw r; return r.json(); }).then(atualizar).then(abrir)
      .catch(function () { f.dataset.tpbNativo = ''; HTMLFormElement.prototype.submit.call(f); })
      .then(function () { if (b) b.disabled = false; });
  });
  // voltar do checkout pelo botão do navegador: a página pode vir do cache com o carrinho antigo
  window.addEventListener('pageshow', function (e) { if (e.persisted) atualizar(); });
})();
